// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerBorder {
    border: 1px solid #D9D9D9 !important;
    border-radius: 10px !important;
    overflow-x: scroll;
}

.routeBade {
    font-family: Poppins;
    background-color: #E4E4FF;
    color: #403E9F;
    font-weight: 500;
    font-size: 12px;
    border-radius: 4px;
    padding: 3px 5px;

}

.routeRuleName.ruleIdError::placeholder {
    color: #FF7F7F;
}

.routeRuleName {
    font-family: Poppins;
    font-size: 20px;
    font-weight: 500;
    outline: none;
}


/* Route Rule Css */

.clearRuleIcons {
    border-radius: 50%;
    background-color: #D9D9D9;
    width: 25px;
    display: flex;
    height: 25px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

/* timeline style  */

.timeLine {
    width: 10px;
    height: 10px;
    background: #403E9F;
}

.timelineCondition {
    background-color: #7F7D83;
}

.timeline-connector {
    background-color: #ADACB0;
    height: 30px;
    width: 2px;

}


.percentage-error-routing {
    display: flex;
    gap: 4px;
    margin-top: 4px;
    align-items: flex-start;


}

.percentage-error-routing .MuiSvgIcon-root {
    color: var(--Comms-Negative, #b9232f);
    height: 14px;
    width: 14px;
}

.percentage-error-routing .MuiTypography-root {
    color: var(--Comms-Negative, #b9232f);
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
}

.timelineContainer {
    padding-left: 20px;
    border-left: 1px solid #ADACB0;
    padding-bottom: 15px;
}

.timelineSeparator {
    position: absolute;
    left: -34px;
    top: 50%;
    transform: translateY(-50%);
    background: white;
    text-transform: capitalize;
    min-width: 30px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.timelineSeparator2 {
    position: absolute;
    left: -34px;
    top: 30%;
    transform: translateY(-50%);
    background: white;
    text-transform: capitalize;
    min-width: 30px;
    height: 28px;
    text-align: center;
}

.timelineText {
    font-size: 14px;
    color: #7F7D83;
    font-family: Poppins;
}

.timelineSeparatorDot {
    background: #403E9F;
    width: 11px;
    height: 11px;
    border: 1px solid #403E9F;
    display: inline-flex;
    border-radius: 50%;
}

.dynamicRoutingText {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

}

.modalBottomBar {
    position: relative;
    box-shadow: 0 -25px 54px -16px rgba(39, 39, 39, 0.15);
    margin-top: 60px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.splitEquallyBtn {
    border-radius: 7px !important;
    font-family: Poppins !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #403E9F !important;
    background-color: #E4E4FF !important;
    height: 30px;
}


.ellipse-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;

}


.ruleHeading,
.ruleHeadingInfo {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    display: block;
}


.ruleHeading {
    font-size: 20px;
    margin: 0;
}

.ruleConditionInfo {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    display: block;
}

.pspRuleContainer {
    position: relative;
    padding-top: 35px;
}

.pspRuleContainer::after {
    content: "";
    position: absolute;
    height: 30px;
    width: 2px;
    background: #ADACB0;
    top: 0;
    left: 20px;

}

.closeEditIcon {
    position: absolute;
    transform: translateX(-50%);
    left: 50%;
    cursor: pointer;
}

.ruleStatus {
    padding: 4px 8px 4px 8px;
    gap: 10px;
    border-radius: 4px ;
    font-size: 12px;
    font-weight: 400;
    display: inline-block;
    margin-left: 10px;
}
.ruleStatus.active {
    background-color: #D5FBD2;
    color: #03A068;
}
.ruleStatus.disabled {
    background-color: #E6E6E6;
    color: #7F7D83;
}
.ruleStatus.draft {
    background-color: #FFF2E8;
    color: #FA8C16;
}
.headerOptionContainer button{
    border:1px solid #E6E6E6;
    border-radius:6px;
    padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/routingRule/routing.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;;AAGA,mBAAmB;;AAEnB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,oBAAoB;;AAEpB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,UAAU;;AAEd;;;AAGA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,uBAAuB;;;AAG3B;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,qDAAqD;IACrD,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,oCAAoC;IACpC,YAAY;AAChB;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;;AAEf;;;AAGA;;IAEI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,MAAM;IACN,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;AAChB","sourcesContent":[".containerBorder {\n    border: 1px solid #D9D9D9 !important;\n    border-radius: 10px !important;\n    overflow-x: scroll;\n}\n\n.routeBade {\n    font-family: Poppins;\n    background-color: #E4E4FF;\n    color: #403E9F;\n    font-weight: 500;\n    font-size: 12px;\n    border-radius: 4px;\n    padding: 3px 5px;\n\n}\n\n.routeRuleName.ruleIdError::placeholder {\n    color: #FF7F7F;\n}\n\n.routeRuleName {\n    font-family: Poppins;\n    font-size: 20px;\n    font-weight: 500;\n    outline: none;\n}\n\n\n/* Route Rule Css */\n\n.clearRuleIcons {\n    border-radius: 50%;\n    background-color: #D9D9D9;\n    width: 25px;\n    display: flex;\n    height: 25px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n/* timeline style  */\n\n.timeLine {\n    width: 10px;\n    height: 10px;\n    background: #403E9F;\n}\n\n.timelineCondition {\n    background-color: #7F7D83;\n}\n\n.timeline-connector {\n    background-color: #ADACB0;\n    height: 30px;\n    width: 2px;\n\n}\n\n\n.percentage-error-routing {\n    display: flex;\n    gap: 4px;\n    margin-top: 4px;\n    align-items: flex-start;\n\n\n}\n\n.percentage-error-routing .MuiSvgIcon-root {\n    color: var(--Comms-Negative, #b9232f);\n    height: 14px;\n    width: 14px;\n}\n\n.percentage-error-routing .MuiTypography-root {\n    color: var(--Comms-Negative, #b9232f);\n    font-family: Poppins;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n}\n\n.timelineContainer {\n    padding-left: 20px;\n    border-left: 1px solid #ADACB0;\n    padding-bottom: 15px;\n}\n\n.timelineSeparator {\n    position: absolute;\n    left: -34px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: white;\n    text-transform: capitalize;\n    min-width: 30px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.timelineSeparator2 {\n    position: absolute;\n    left: -34px;\n    top: 30%;\n    transform: translateY(-50%);\n    background: white;\n    text-transform: capitalize;\n    min-width: 30px;\n    height: 28px;\n    text-align: center;\n}\n\n.timelineText {\n    font-size: 14px;\n    color: #7F7D83;\n    font-family: Poppins;\n}\n\n.timelineSeparatorDot {\n    background: #403E9F;\n    width: 11px;\n    height: 11px;\n    border: 1px solid #403E9F;\n    display: inline-flex;\n    border-radius: 50%;\n}\n\n.dynamicRoutingText {\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 20px;\n\n}\n\n.modalBottomBar {\n    position: relative;\n    box-shadow: 0 -25px 54px -16px rgba(39, 39, 39, 0.15);\n    margin-top: 60px;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.splitEquallyBtn {\n    border-radius: 7px !important;\n    font-family: Poppins !important;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    color: #403E9F !important;\n    background-color: #E4E4FF !important;\n    height: 30px;\n}\n\n\n.ellipse-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n\n}\n\n\n.ruleHeading,\n.ruleHeadingInfo {\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    display: block;\n}\n\n\n.ruleHeading {\n    font-size: 20px;\n    margin: 0;\n}\n\n.ruleConditionInfo {\n    font-family: Poppins;\n    font-size: 16px;\n    font-weight: 500;\n    display: block;\n}\n\n.pspRuleContainer {\n    position: relative;\n    padding-top: 35px;\n}\n\n.pspRuleContainer::after {\n    content: \"\";\n    position: absolute;\n    height: 30px;\n    width: 2px;\n    background: #ADACB0;\n    top: 0;\n    left: 20px;\n\n}\n\n.closeEditIcon {\n    position: absolute;\n    transform: translateX(-50%);\n    left: 50%;\n    cursor: pointer;\n}\n\n.ruleStatus {\n    padding: 4px 8px 4px 8px;\n    gap: 10px;\n    border-radius: 4px ;\n    font-size: 12px;\n    font-weight: 400;\n    display: inline-block;\n    margin-left: 10px;\n}\n.ruleStatus.active {\n    background-color: #D5FBD2;\n    color: #03A068;\n}\n.ruleStatus.disabled {\n    background-color: #E6E6E6;\n    color: #7F7D83;\n}\n.ruleStatus.draft {\n    background-color: #FFF2E8;\n    color: #FA8C16;\n}\n.headerOptionContainer button{\n    border:1px solid #E6E6E6;\n    border-radius:6px;\n    padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
